module.exports = __webpack_public_path__ + "static/img/block-bg2.0b23a991.png";